module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.15535/images/logos/linkedin.png"